<template>
    <v-card class="elevation-1" :style="isMobile?'margin-bottom:-3px':'margin-bottom:20px'"> 
        <v-toolbar flat height="40px" @click="commentsVisible=!commentsVisible" title="Comments" class="clickable">
            <v-icon>forum</v-icon>
            <b class="ml-10">COMMENTS</b>
            <v-spacer></v-spacer>
            <v-btn v-if="commentsVisible" icon title="Minimize">
                <v-icon>expand_less</v-icon>
            </v-btn>
            <v-btn v-if="!commentsVisible" icon title="Expand">
                <v-icon>expand_more</v-icon>
            </v-btn>
        </v-toolbar>
        <p v-if="error" class="red--text">{{errorMessage}}</p>
        <div v-if="commentsVisible">
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs1>
                        <v-list-tile-avatar size="30" class="text-xs-center">
                            <v-img ref="avatar" :src="myAvatar"></v-img> 
                        </v-list-tile-avatar>                    
                    </v-flex>
                    <v-flex xs11 class="text-xs-left mt-0">
                        <v-text-field color="primary"
                            v-model="message"
                            append-icon="send"
                            clear-icon="clear"
                            box clearable
                            label="Add comment"
                            type="text"
                            max="1000"
                            :style="isMobile?'margin-left:10px':''"
                            @click:append="postComment"
                            @keypress="keypressHandler"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-data-table
                :headers="headers"
                :items="messages.slice()"
                :loading="loading"
                hide-headers
                :hide-actions="messages.length<6"
                style="margin-top:-30px;"
            >
                <template v-slot:no-data>
                    <div class="caption text-xs-center">No messages found</div>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td>
                            <div class="messages-container">
                                <v-layout row wrap>
                                    <v-flex xs1>
                                        <v-list-tile-avatar size="30" class="text-xs-center">
                                            <img :src="getAvatarUrl(props.item)">
                                        </v-list-tile-avatar>                            
                                    </v-flex>
                                    <v-flex xs11 class="text-xs-left">
                                        <span class="caption" :style="isMobile?'margin-left:8px':''">
                                            <b>{{props.item.sender}}</b>, 
                                            <span :title="props.item.postDateFullFmt">{{props.item.postDate}}</span>
                                        </span>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs1></v-flex>
                                    <v-flex xs11 class="text-xs-left message-container">
                                        <div class="text-xs-left" :style="isMobile?'margin-left:10px':''" v-html="props.item.message"></div>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table> 
        </div>
    </v-card>
</template>
<script>

import commentsHistoryApi from '@/api/commentshistory'
import notificationsApi from '@/api/notifications'
import Vue from 'vue'
import awsS3Helper from '@/helpers/aws-s3'
import { getExpandCollapseVisibility, updateExpandCollapseVisibility } from '@/helpers/user-prefs'
import { formatCreatedDate } from '@/helpers/date-helpers'

const signalR = require('@microsoft/signalr'); 
Vue.prototype.$signalR = signalR;

export default {
    data() {
        return {
            error: false,
            errorMessage: null,
            signalRConnection: null,    
            message: null,
            messages: [],
            headers: [
                {text: 'Message',align: 'left',value: '', width: '100%', sortable:false}
             ],
            loading: false,
            commentsVisible: getExpandCollapseVisibility(this.$route.name, 'comments-history'),
        }
    },
    props: ['comments_data'],
    methods: {
        keypressHandler(event) {
            if (event.code=='Enter') this.postComment()
        },
        async initializeSignalR() {
            await this.signalRConnection.start().catch(err => console.error(err));
            await this.signalRConnection.invoke(process.env.VUE_APP_HUB_COMMENTSHISTORY_INVOKE, this.comments_data.pageQueryId);
            
            this.signalRConnection.on(process.env.VUE_APP_HUB_COMMENTSHISTORY_ALERT, data => {
                this.commentsVisible = true
                this.messages.unshift(
                    {
                        message: data.message,
                        sender: data.sender,  
                        userId: data.userId,
                        postDateFullFmt: this.$moment(data.createdOn).format('MMM DD, YYYY hh:mma'),
                        postDate: formatCreatedDate(data.postDate)
                    }
                )
            });
        },
        async invokeSubscribe() {
            await this.signalRConnection.invoke(process.env.VUE_APP_HUB_COMMENTSHISTORY_INVOKE, this.comments_data.pageQueryId);
        },
        postComment() {
            if (this.message) {
                var data = {
                    message: this.message,
                    createdBy: this.$store.state.userId,    //logged-in userid
                    pageQueryId: this.comments_data.pageQueryId
                }
                this.signalRConnection.invoke('postComment', data).catch(err => console.error(err));
                
                if (this.comments_data.pageLink && this.comments_data.notificationTypeId) {
                    this.sendCommentsNotification()
                }else{
                    this.message = null
                }
            }
        },
        async sendCommentsNotification() {
            try {
                //this is for refactoring in the future
                //need to separate props for sending notif when comment is created
                const message = this.message
                this.message = null
                var data = {
                    pageQueryId: this.comments_data.pageQueryId,
                    comment: message,
                    createdBy: this.$store.state.userId,
                    pageItemCreatedBy: this.comments_data.pageItemCreatedBy,
                    pageLink: this.comments_data.pageLink,
                    pageKey: this.comments_data.pageKey,    
                    notificationTypeId: this.comments_data.notificationTypeId
                }
                await notificationsApi.sendCommentsNotification(data)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async getCommentsHistory() {
            try {
                this.loading = true
                this.messages = []
                const response = await commentsHistoryApi.getAll(this.comments_data.pageQueryId)
                if (response.status == 200) {
                    response.data.items.forEach(item => {
                        this.messages.push(
                            {
                                message: item.comment,
                                sender: item.sender,  
                                userId: item.userId,
                                postDateFullFmt: this.$moment(item.createdOn).format('MMM DD, YYYY hh:mma'),
                                postDate: formatCreatedDate(item.createdOn)
                            }
                        )
                    })
                }

                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        getAvatarUrl(data) {
            //lightweight workaround to pull SweldoNow Employees avatar when viewed from customer's account
            //Pages such as Company Billing page
            //For now only SweldoNow Billing (billing@sweldonow.ph) will be used to manage customer's billing processing
            //This can be refactored in the future
            if (data.sender == 'SweldoNow Billing') {
                return awsS3Helper.getSweldoNowAvatarUrl(data.userId)
            }else{
                return awsS3Helper.getAvatarUrl(data.userId)
            }
        }
    },
    created() {
        this.getCommentsHistory()

        //signalR
        this.signalRConnection = new this.$signalR.HubConnectionBuilder()
                          .withUrl(`${process.env.VUE_APP_HUB_URL}commentshistory`) 
                          .configureLogging(this.$signalR.LogLevel.Information)
                          .withAutomaticReconnect()
                          .build()
    },
    async mounted() { 
        await this.initializeSignalR()
    },
    watch: {
        commentsVisible(newVal) {
            updateExpandCollapseVisibility(this.$route.name,  'comments-history', newVal)
        }
    },
    computed: {
        myAvatar() {
            return awsS3Helper.getAvatarUrl(this.$store.state.userId)
        },
    },
    destroyed() {
        this.signalRConnection = null
    },
}
</script>
<style scoped>

/* these are for refactor/improvements */
.messages-container {
    margin:10px 0px -10px -8px;
}
.message-container {
    margin:-15px 0px 15px 0px;
}
</style>